// Stylus detection via touchEvents is unreliable (false positives on Android).
// Rather than refactor to pointerEvents everywhere, we track stylus state globally
// using pointerEvents (which reliably detect stylus) and expose it via getIsCurrentlyUsingStylus().

let isCurrentlyUsingStylus = false;

export function initiateStylusTouchDetection() {
  function setFlagFromEvent(event: PointerEvent) {
    isCurrentlyUsingStylus = event.pointerType === 'pen';
  }

  function resetFlag() {
    isCurrentlyUsingStylus = false;
  }

  document.addEventListener('pointerdown', setFlagFromEvent, { capture: true });
  document.addEventListener('pointermove', setFlagFromEvent, { capture: true });
  document.addEventListener('pointerup', resetFlag, { capture: true });
  document.addEventListener('pointercancel', resetFlag, { capture: true });

  return () => {
    document.removeEventListener('pointerdown', setFlagFromEvent, { capture: true });
    document.removeEventListener('pointermove', setFlagFromEvent, { capture: true });
    document.removeEventListener('pointerup', resetFlag, { capture: true });
    document.removeEventListener('pointercancel', resetFlag, { capture: true });
  };
}

export function getIsCurrentlyUsingStylus(): boolean {
  return isCurrentlyUsingStylus;
}
